import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// import { getWyList } from '../../../services/api';
// import { rel } from '../../utils/rel';

/**
 * 定义 委员列表 组件
 */

class NavList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };
    /**
     * 渲染组件
     */
    render() {
        const { content, letter, changeLetter } = this.props;

        // console.log('lleete==', letter);
        const navMap = content.map((item, index) => {
            if (item === letter) {
                return (
                    <a key={index} className={styles.auNavCur} onClick={() => changeLetter(item)}>
                        {item}
                    </a>
                );
            } else {
                return (
                    <a key={index} onClick={() => changeLetter(item)}>
                        {item}
                    </a>
                );
            }
        });

        return <div className={styles.auNav}>{navMap}</div>;
    }
}

NavList.propTypes = { content: PropTypes.array, changeLetter: PropTypes.func, letter: PropTypes.string };

export default errorBoundary(NavList);
